module.exports = __webpack_public_path__ + "static/media/07-Model-2.0703127b.webp";